import { consola } from 'consola'

export const logger = consola

export function useLogger(tag?: string) {
  return tag ? logger.withTag(tag) : logger
}

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      currency: (val: number, showCents: boolean = true) => {
        if (isNaN(val)) return;
        val /= 100;
        return nuxtApp.$i18n.n(val, showCents ? 'currency' : 'currencyNoCents');
      },
      logger: useLogger('storefront'),
    }
  };
});
